import {AsyncPipe} from "@angular/common";
import {Component, inject} from "@angular/core";
import {FlexModule} from "@angular/flex-layout";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {LeasePosComponent} from "@features/leasing/lease-pos/lease-pos.component";
import {LoadingService} from "@ui-kit/utils/service/loading.service";
import {PageHeaderComponent} from "@ui-webkit/components/page-header/page-header.component";


@Component({
  selector: 'app-leasing-pos',
  standalone: true,
  imports: [
    AsyncPipe,
    FlexModule,
    MatProgressBarModule,
    PageHeaderComponent,
    LeasePosComponent
  ],
  templateUrl: './leasing-pos.component.html',
  styleUrl: './leasing-pos.component.scss'
})
export class LeasingPosComponent {
  private _loader = inject(LoadingService);
  protected loading$ = this._loader.loading$;
}
